import api from './api'

export interface CheckoutFulfillmentConfig {
  enabled: boolean
  askMethod: boolean
  askAddress: boolean
  methodPrompt: string
  addressPrompt: string
  pickupInstructions: string
  deliveryInstructions: string
  shippingInfo: string | null
  shippingZones: string[]
  orderWaitWarnMinutes?: number | null
  orderWaitCriticalMinutes?: number | null
}

export interface FaqBridgeConfig {
  productBridgeText: string
  multipleProductsBridgeText: string
  genericBridgeText: string
  productStatementText: string
  multipleProductsStatementText: string
  genericStatementText: string
}

export interface FaqBridgePreset {
  id: string
  label: string
  description: string
  config: FaqBridgeConfig
}

export interface EscalationConfig {
  handoffRecipientLabel: string
  escalationMessage: string
  maxResponsesMessage: string
}

export interface EscalationPreset {
  id: string
  label: string
  description: string
  config: EscalationConfig
}

export const DEFAULT_FAQ_BRIDGE_CONFIG: FaqBridgeConfig = {
  productBridgeText:
    '¡Excelente elección con la *{{product}}*! Si te parece, la dejamos apartada y coordinamos los datos de entrega. ¿Avanzamos?',
  multipleProductsBridgeText:
    'Con gusto. ¿Te gustaría que comparemos *{{productA}}* y *{{productB}}* para ver cuál se adapta mejor a lo que buscas?',
  genericBridgeText:
    'Con gusto. ¿Buscas algún producto en especial o te gustaría conocer opciones de nuestro catálogo o recomendaciones?',
  productStatementText: '¿Continuamos con tu orden de *{{product}}* para coordinar la entrega?',
  multipleProductsStatementText: '¿Te gustaría que comparemos las opciones activas para ayudarte a decidir?',
  genericStatementText: '¿Te gustaría ver más opciones de nuestro catálogo o revisar recomendaciones?',
}

import type { ReengagementConfig } from '@/lib/api/botSettings'
export type { ReengagementConfig }

// Tipos para la configuración del bot
export interface BotSettingsDTO {
  aiEnabled: boolean
  tone: string
  language: string
  promptBase: string | null
  model: string | null
  temperature: number | null
  maxTokens: number | null
  botName: string | null
  avatar: string | null
  persona: 'Professional' | 'Friendly' | 'Tech' | null
  welcomeMessage: string | null
  typingSimulation: boolean
  commercialPolicyConfig?: Record<string, unknown> | null
  checkoutConfig?: CheckoutFulfillmentConfig
  faqBridgeConfig?: FaqBridgeConfig
  faqBridgePresets?: FaqBridgePreset[]
  faqBridgePresetId?: string | null
  escalationPresetId?: string | null
  escalationPresets?: EscalationPreset[]
  reengagementConfig?: ReengagementConfig
  // Configuración de escalamiento
  maxBotResponses: number | null
  handoffRecipientLabel: string | null
  escalationMessage: string | null
  maxResponsesMessage: string | null
}

/**
 * Obtiene la configuraciÃ³n del bot
 */
async function getSettings(): Promise<BotSettingsDTO> {
  const response = await api.get<BotSettingsDTO>('/bot/settings')
  return response.data
}

/**
 * Actualiza la configuraciÃ³n del bot
 */
async function updateSettings(data: Partial<BotSettingsDTO>): Promise<BotSettingsDTO> {
  const response = await api.put<BotSettingsDTO>('/bot/settings', data)
  return response.data
}

export const botSettingsApi = {
  getSettings,
  updateSettings,
}

